import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const local_ui_set_key_is_shift_pressed = (isPressed: boolean): PayloadAction<boolean> => ({
  type: ENUM__redux_action.UI_KEY_SET_IS_SHIFT_PRESSED,
  payload: isPressed,
});

export const init_local_ui_set_key_is_shift_pressed = (state: STATE__ui, action: PayloadAction<boolean>) => {
  state.global__is_shift_pressed = action.payload;
};
